import {isReleasedRedesignRecruitment} from '../../../../../config/unReleasePage';
import type {CommunityTopic} from '../../../../../core/entities/community/schema';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {FollowCommunityTopicButton} from '../../../../../shared/components/FollowCommunityTopicButton';
import {formatDate} from '../../../../../shared/services/formatDate';

export const CommunityTopicComponent: React.FC<{
  topic: CommunityTopic;
}> = ({topic}) => {
  const updatedAt = formatDate(topic.lastPostedAt);

  if (isReleasedRedesignRecruitment()) {
    return (
      <div className="flex justify-between border-b-[1px] [&:nth-last-child(1)]:border-b-0 border-collapse border-line-1 pb-12 [&:nth-last-child(1)]:pb-0 mb-16 [&:nth-last-child(1)]:mb-0">
        <div className="w-[calc(100%-67px)]">
          <div className="flex flex-wrap">
            <p className="bg-black-3 text-xs text-white rounded-16 py-4 px-8 text-center">
              {updatedAt}&nbsp;更新
            </p>
          </div>
          <CommonLink
            className="block mt-8 pc:hover:opacity-80"
            href={`/questions/${topic.id}`}
          >
            <p className="text-md text-black leading font-bold">
              {topic.title}
            </p>
            <p className="text-base text-black-2 leading line-clamp-2 mt-8">
              {topic.body}
            </p>
          </CommonLink>
        </div>
        <div className="w-[55px] ml-12">
          <FollowCommunityTopicButton
            topicId={topic.id}
            isFollowedInitial={topic.followed}
            followCountInitial={topic.followerCount}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-between border-b-[1px] [&:nth-last-child(1)]:border-b-0 border-collapse border-line-1 pb-12 [&:nth-last-child(1)]:pb-0 mb-16 [&:nth-last-child(1)]:mb-0">
      <div className="w-[calc(100%-67px)]">
        <div className="flex flex-wrap">
          <p className={'bg-black-3 text-xs text-white py-2 px-8 text-center'}>
            {updatedAt}&nbsp;更新
          </p>
        </div>
        <CommonLink
          className="block mt-8 pc:hover:opacity-80"
          href={`/questions/${topic.id}`}
        >
          <p className="text-md text-black leading font-bold">{topic.title}</p>
          <p className="text-base text-black-2 leading line-clamp-2 mt-8">
            {topic.body}
          </p>
        </CommonLink>
      </div>
      <div className="w-[55px] ml-12">
        <FollowCommunityTopicButton
          topicId={topic.id}
          isFollowedInitial={topic.followed}
          followCountInitial={topic.followerCount}
        />
      </div>
    </div>
  );
};
